import React, { useContext } from 'react';
import { format, parseISO } from 'date-fns';
import { LeadPageContext } from '@/modules/lead-page/context/lead-page.context';
import { useWhatsappConversations } from '@/modules/lead-page/new/hooks/whatsapp-conversations.hook';
import { useZoomCallsActivity } from '@/modules/lead-page/new/hooks/zoom-calls-activity.hook';

const ChatsAndCallsLastActivity: React.FC = () => {
  const { lead } = useContext(LeadPageContext);
  const journeyUid = (lead?.data?.lead?.journey_uid as string) ?? '';

  const { agentGroups } = useWhatsappConversations(journeyUid);

  const { zoomItems } = useZoomCallsActivity(journeyUid);

  const latestIso = (() => {
    const candidates: number[] = [];
    agentGroups.forEach((c) => {
      const t = new Date(c.lastMessageAt).getTime();
      if (!Number.isNaN(t)) candidates.push(t);
    });
    zoomItems.forEach((item) => {
      const t = new Date(item.createdAt).getTime();
      if (!Number.isNaN(t)) candidates.push(t);
    });
    if (candidates.length === 0) return null;
    return new Date(Math.max(...candidates)).toISOString();
  })();

  if (!latestIso) return <>WhatsApp · Zoom</>;

  return <>Last message {format(parseISO(latestIso), 'd MMM yyyy, h:mm a')}</>;
};

export default ChatsAndCallsLastActivity;
